import find from 'lodash/find';
import get from 'lodash/get';

import {localeOptions, RTL_LOCALES} from '@utils/locales/locales';

import analyticsService from '../../../services/analytics';
import localization from '../../../services/localization';
import enMessages from '../../../translations/en.json';
import * as types from './types';

export const initialize = () => {
  return (dispatch, getState) => {
    const systemLanguage = localization.getSystemLanguage();
    const storageLanguage = localization.getLocalStorageLanguage();
    const reduxLanguage = get(getState(), ['localization', 'locale']);

    const language = storageLanguage || reduxLanguage || systemLanguage;

    return dispatch(setLanguage(language));
  };
};

/**
 *
 * @param {LOCALES} language
 * @returns {Function}
 */
export const setLanguage = (language) => {
  return (dispatch, getState) => {
    return localization.updateLocaleDataAsync(language).then((localData) => {
      localization.setLocalStorageLanguage(language);
      localData.languageName = find(localeOptions, ['value', language]).label;
      document.documentElement.dir = RTL_LOCALES.includes(language) ? 'rtl' : 'ltr';

      dispatch({type: types.LOCALE_SET, payload: localData});
      dispatch({type: types.INTEL_LOCALE_RESET});

      analyticsService.updateAnalytics(getState());
    });
  };
};

export const setIntelLocaleEnglish = () => {
  return (dispatch) => {
    dispatch({
      type: types.INTEL_LOCALE_SET,
      payload: {intelLocale: 'en', intelMessages: enMessages},
    });
  };
};

export const resetIntelLocale = () => {
  return (dispatch) => {
    dispatch({
      type: types.INTEL_LOCALE_RESET,
    });
  };
};
